module.exports = __webpack_public_path__ + "img/file-code-information-1.3d30ce01.svg";